module.exports = __webpack_public_path__ + "static/media/SVLogoBlackOrange.6bd2cddd.svg";